export default __webpack_public_path__ + "static/media/LUNAw.b192f8dc.png";